// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrintFactor_sectionPrintFactor__RAb75 {
    margin-top: -120px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.PrintFactor_header_printFactor__1GAN1 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    padding: 8px;
    background: var(--color-white);
    box-shadow: var(--shadow-1);
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
    max-width: 1400px;

}

.PrintFactor_right_header__PBg\\+r>img {
    width: 100px;
}

.PrintFactor_right_header__PBg\\+r>button {
    background: var(--color-primary);
    margin-left: 8px;
    padding: 4px;
    border-radius: var(--radius-small);
    -webkit-border-radius: var(--radius-small);
    -moz-border-radius: var(--radius-small);
    -ms-border-radius: var(--radius-small);
    -o-border-radius: var(--radius-small);
}

.PrintFactor_header_printFactor__1GAN1>.PrintFactor_left_header__cYUlo {
    padding: 0;
    margin: 0;
}


.PrintFactor_header_printFactor__1GAN1>.PrintFactor_left_header__cYUlo>button {
    font-size: 1rem;
    padding: 6px 16px;
    border-radius: var(--radius-global);
    -webkit-border-radius: var(--radius-global);
    -moz-border-radius: var(--radius-global);
    -ms-border-radius: var(--radius-global);
    -o-border-radius: var(--radius-global);
}

.PrintFactor_header_printFactor__1GAN1>.PrintFactor_left_header__cYUlo>button:nth-child(1) {
    display: none;
    background: rgba(255, 141, 7, 0.08);
    color: #FF8D07;
    margin-left: 16px;
}

.PrintFactor_header_printFactor__1GAN1>.PrintFactor_left_header__cYUlo>button:nth-child(2) {
    background: var(--color-primary-100);
    color: var(--color-primary);
}

.PrintFactor_factor__JqL1W table, .PrintFactor_factor__JqL1W td, .PrintFactor_factor__JqL1W th {
    border: 1px solid !important;
    border-color: var(--color-neutral-900) !important;
    font-size: .9rem;
    padding: 8px 4px;
    color: var(--color-neutral-600);
    text-align: right;
}

.PrintFactor_factor__JqL1W .PrintFactor_thead__9zIZV img {
    max-width: 200px;
}


.PrintFactor_factor__JqL1W th {
    background: var(--color-neutral-100);
    color: var(--color-neutral-600);
}

.PrintFactor_factor__JqL1W {
    width: 100%;
    overflow: auto;
    max-width: 1400px;

}

.PrintFactor_factor__JqL1W table {
    width: 1200px;
    border-collapse: collapse;
}

.PrintFactor_factor__JqL1W .PrintFactor_thead__9zIZV th {
    background-color: var(--color-white);
    padding: 24px;
    border: none !important;
    font-size: 1.2rem;
}

.PrintFactor_factor__JqL1W .PrintFactor_thead__9zIZV th:nth-child(2) {
    text-align: center;
}

.PrintFactor_factor__JqL1W .PrintFactor_thead__9zIZV th:last-child {
    text-align: left;
    font-size: .8rem;
}

.PrintFactor_serviceImage__3FbJt {
    width: 200px;
    height: 125px;
    object-fit: cover;
    border-radius: 10px;
    border: 1px solid black;
    cursor: pointer;
}

@media only screen and (min-width: 768px) {

    .PrintFactor_header_printFactor__1GAN1>.PrintFactor_left_header__cYUlo>button:nth-child(1) {
        display: inline;
    }

    .PrintFactor_right_header__PBg\\+r>button {
        display: none;
    }

    .PrintFactor_right_header__PBg\\+r>img {
        width: 132px;
    }

    .PrintFactor_header_printFactor__1GAN1 {
        padding: 16px;
    }
}

@media only screen and (min-width: 992px) {
    .PrintFactor_factor__JqL1W table {
        width: 100%;
    }
}

@media print {
    .PrintFactor_header_printFactor__1GAN1 {
        display: none !important;
    }

    .PrintFactor_factor__JqL1W table {
        width: 100%;
    }

}
`, "",{"version":3,"sources":["webpack://./src/Styles/PrintFactor.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;IACtC,iBAAiB;;AAErB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,mCAAmC;IACnC,2CAA2C;IAC3C,wCAAwC;IACxC,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,iDAAiD;IACjD,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;IACf;;AAEJ","sourcesContent":[".sectionPrintFactor {\n    margin-top: -120px;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.header_printFactor {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n    padding: 8px;\n    background: var(--color-white);\n    box-shadow: var(--shadow-1);\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n    max-width: 1400px;\n\n}\n\n.right_header>img {\n    width: 100px;\n}\n\n.right_header>button {\n    background: var(--color-primary);\n    margin-left: 8px;\n    padding: 4px;\n    border-radius: var(--radius-small);\n    -webkit-border-radius: var(--radius-small);\n    -moz-border-radius: var(--radius-small);\n    -ms-border-radius: var(--radius-small);\n    -o-border-radius: var(--radius-small);\n}\n\n.header_printFactor>.left_header {\n    padding: 0;\n    margin: 0;\n}\n\n\n.header_printFactor>.left_header>button {\n    font-size: 1rem;\n    padding: 6px 16px;\n    border-radius: var(--radius-global);\n    -webkit-border-radius: var(--radius-global);\n    -moz-border-radius: var(--radius-global);\n    -ms-border-radius: var(--radius-global);\n    -o-border-radius: var(--radius-global);\n}\n\n.header_printFactor>.left_header>button:nth-child(1) {\n    display: none;\n    background: rgba(255, 141, 7, 0.08);\n    color: #FF8D07;\n    margin-left: 16px;\n}\n\n.header_printFactor>.left_header>button:nth-child(2) {\n    background: var(--color-primary-100);\n    color: var(--color-primary);\n}\n\n.factor table, .factor td, .factor th {\n    border: 1px solid !important;\n    border-color: var(--color-neutral-900) !important;\n    font-size: .9rem;\n    padding: 8px 4px;\n    color: var(--color-neutral-600);\n    text-align: right;\n}\n\n.factor .thead img {\n    max-width: 200px;\n}\n\n\n.factor th {\n    background: var(--color-neutral-100);\n    color: var(--color-neutral-600);\n}\n\n.factor {\n    width: 100%;\n    overflow: auto;\n    max-width: 1400px;\n\n}\n\n.factor table {\n    width: 1200px;\n    border-collapse: collapse;\n}\n\n.factor .thead th {\n    background-color: var(--color-white);\n    padding: 24px;\n    border: none !important;\n    font-size: 1.2rem;\n}\n\n.factor .thead th:nth-child(2) {\n    text-align: center;\n}\n\n.factor .thead th:last-child {\n    text-align: left;\n    font-size: .8rem;\n}\n\n.serviceImage {\n    width: 200px;\n    height: 125px;\n    object-fit: cover;\n    border-radius: 10px;\n    border: 1px solid black;\n    cursor: pointer;\n}\n\n@media only screen and (min-width: 768px) {\n\n    .header_printFactor>.left_header>button:nth-child(1) {\n        display: inline;\n    }\n\n    .right_header>button {\n        display: none;\n    }\n\n    .right_header>img {\n        width: 132px;\n    }\n\n    .header_printFactor {\n        padding: 16px;\n    }\n}\n\n@media only screen and (min-width: 992px) {\n    .factor table {\n        width: 100%;\n    }\n}\n\n@media print {\n    .header_printFactor {\n        display: none !important;\n    }\n\n    .factor table {\n        width: 100%;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionPrintFactor": `PrintFactor_sectionPrintFactor__RAb75`,
	"header_printFactor": `PrintFactor_header_printFactor__1GAN1`,
	"right_header": `PrintFactor_right_header__PBg+r`,
	"left_header": `PrintFactor_left_header__cYUlo`,
	"factor": `PrintFactor_factor__JqL1W`,
	"thead": `PrintFactor_thead__9zIZV`,
	"serviceImage": `PrintFactor_serviceImage__3FbJt`
};
export default ___CSS_LOADER_EXPORT___;
